import './App.css';
import React, { useEffect, useState } from "react";



//var selectedCategory = 'gk'; // Default category
var currentuserid = '';

// Check if the URL has a query string and extract the CategoryName if it exists
let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      // selectedCategory = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}

function Leaderboard() { 
const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; // https://kc-service-eight.vercel.app // http://localhost:3000

const [leaderboardData, setLeaderboardData] = useState([]);

async function fetchLeaderboardData( ) {
  try {
    console.log('Fetching leaderboard data for user:', currentuserid);
    const type = document.getElementById('type').value;
    console.log('Selected type:', type);
    const selectedTimeframe = document.getElementById('timeframe').value;
    console.log('Selected timeframe:', selectedTimeframe);
    let responseAfterDate = null;
    console.log('Initial responseAfterDate:', responseAfterDate);

    switch (selectedTimeframe) {
      case 'today':
      responseAfterDate = new Date().toISOString().split('T')[0];
      break;
      case 'last1week':
      responseAfterDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      break;
      case 'last1month':
      responseAfterDate = new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0];
      break;
      case 'last1year':
      responseAfterDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0];
      break;
      default:
      responseAfterDate = '1900-01-01';
    }
  console.log('Computed responseAfterDate:', responseAfterDate);

    const response = await fetch(KC_SERVICE + '/dashboard_CategoryLeaders', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userid: currentuserid.split('-')[0],
        responseAfterDate,
        type,
      }),
    });
    const data = await response.json();

    // console.log('Fetched leaderboard data:', data);

    setLeaderboardData(data.Leaderboard);
  } catch (err) {
    console.error('Error:', err.message);
  }
}

useEffect(() => {
  fetchLeaderboardData();
}, );

return (
  <div style={{ padding: '24px', maxWidth: 800, fontFamily: 'Arial, sans-serif' }}>
    <h1 style={{ textAlign: 'center', color: '#4CAF50' }}>Leaderboard</h1>
    <div style={{ textAlign: 'center', marginBottom: '16px' }}>
      <label htmlFor="timeframe" style={{ marginRight: '8px', fontWeight: 'bold' }}>Timeframe:</label>
      <select
        id="timeframe"
        style={{ padding: '8px', fontSize: '16px', marginRight: '16px' }}
        onChange={async (e) => {
          const selectedTimeframe = e.target.value;
          let responseAfterDate;

          switch (selectedTimeframe) {
            case 'today':
              responseAfterDate = new Date().toISOString().split('T')[0];
              break;
            case 'last1week':
              responseAfterDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
              break;
            case 'last1month':
              responseAfterDate = new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0];
              break;
            case 'last1year':
              responseAfterDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0];
              break;
            default:
              responseAfterDate = '1900-01-01';
              console.log(responseAfterDate);
          }

          try {
            await fetchLeaderboardData();
          } catch (err) {
            console.error('Error:', err);
          }
        }}
      >
        <option value="all">All</option>
        <option value="today">Today</option>
        <option value="last1week">Last 1 Week</option>
        <option value="last1month">Last 1 Month</option>
        <option value="last1year">Last 1 Year</option>
      </select>

      <label htmlFor="type" style={{ marginRight: '8px', fontWeight: 'bold' }}>Type:</label>
      <select
        id="type"
        style={{ padding: '8px', fontSize: '16px' }}
        onChange={async (e) => {
          //const selectedType = e.target.value;

          try {
            await fetchLeaderboardData(currentuserid.split('-')[0],);
          } catch (err) {
            console.error('Error:', err);
          }
        }}
      >
        <option value="individual">Individual Score</option>
        <option value="challenge">Challenge Score</option>
      </select>
    </div>
    <table
      style={{
        width: '100%',
        marginTop: '16px',
        borderCollapse: 'collapse',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#f4f4f4',
      }}
    >
      <thead>
        <tr style={{ backgroundColor: '#4CAF50', color: 'white' }}>
          <th style={{ padding: '12px', textAlign: 'left' }}>Category</th>
          <th style={{ padding: '12px', textAlign: 'left' }}>Rank 1 🥇</th>
          <th style={{ padding: '12px', textAlign: 'left' }}>Rank 2 🥈</th>
          <th style={{ padding: '12px', textAlign: 'left' }}>Rank 3 🥉</th>
        </tr>
      </thead>
      <tbody>
        {leaderboardData.map((category, index) => (
          <tr
            key={category.categoryname}
            style={{
              backgroundColor: index % 2 === 0 ? '#e9e9e9' : '#ffffff',
              borderBottom: '1px solid #ddd',
            }}
          >
            <td style={{ padding: '12px' }}>{category.categoryname}</td>
            <td style={{ padding: '12px', color: 'blue', fontWeight: 'bold' }}>
              {category.rank1
                ? `${category.rank1.username} (Score: ${category.rank1.total_score})`
                : 'N/A'}
            </td>
            <td style={{ padding: '12px', color: 'orange', fontWeight: 'bold' }}>
              {category.rank2
                ? `${category.rank2.username} (Score: ${category.rank2.total_score})`
                : 'N/A'}
            </td>
            <td style={{ padding: '12px', color: '#8B4513', fontWeight: 'bold' }}>
              {category.rank3
                ? `${category.rank3.username} (Score: ${category.rank3.total_score})`
                : 'N/A'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
}

export default Leaderboard;